import React, { Component } from 'react';

import LoadingIndication from '../../common/loading-indicator';
import adminStatsService from '../../../services/admin-stats/admin-stats';
import { Chart } from './bar-chart';
import { sortBy } from 'lodash';

function convertToObjectForEachTag(stats) {
  const tags = Object.keys(stats[0]).filter(x=>x!=='date');
  const convertedData = tags.map(tag => {
    return stats.reduce((res, dayData) => {
      return {
        ...res,
        [dayData.date]: dayData[tag],
      };
    }, { tag });
  });

  return sortBy(convertedData, Object.keys(convertedData[0]).filter(key => key !== 'tag').reverse()).reverse();
}

class BarChartOvertimeStats extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      isError: false,      
      stats: [],
    };
  }

  componentDidMount() {
    const { metricPrefix, days = 4, tags = true } = this.props;
    const action = tags ? adminStatsService.getStatsTagsOverTimeByNumOfDays : adminStatsService.getStatsOverTimeByNumOfDays;

    action(metricPrefix, days)
      .then((stats) => {
        this.setState(() => {
          const convertedData = convertToObjectForEachTag(stats);
          return {
            isLoading: false,
            isError: false,
            stats: convertedData,
            xKeys: convertedData.length > 0 ? Object.keys(convertedData[0]).filter(x=>x!=='tag').sort((a, b) => {
              const [d1, m1] = a.split('/');
              const [d2, m2] = b.split('/');
              return `${m1}${d1}` > `${m2}${d2}` ? 1 : -1;
            }) : [],
          };
        }); 
      })
      .catch(error => {
        console.error('BarChartOvertimeStats::componentDidMount', error);
        this.setState({
          isLoading: false,
          isError: true
        });
      });
  }

  render() {
    if (this.state.isLoading) {
      return <LoadingIndication />;
    }

    if (this.state.isError) return <div>Error</div>;

    const { stats, xKeys } = this.state;

    const statsSeparation = [];
    const tagsPerChart = 7;
    for (let i = 0; i < stats.length; i += tagsPerChart) {
      statsSeparation.push(stats.slice(i, i + tagsPerChart));
    } 

    return (
      <div style={{ margin: '30px 0' }}>

        {
          statsSeparation.map(chartStats => (
            <Chart stats={chartStats} xKeys={xKeys} />
          ))
        }
      </div>
    );
  }
}

export default BarChartOvertimeStats;
